// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1GfJk","primary":"Button_primary__1-y87","info":"Button_info__27Aiz","outline":"Button_outline__2aGC2"};